/*jslint browser: true, unparam: true, nomen: true, maxerr: 50, indent: 3 */

/**
 * Free Text Search Module
 */
define(['jquery', 'c21/track', 'c21/ajax'], function ($, track, ajax) {
   "use strict";

   var FreeTextSearch = function () {
      var self = this;

      this.initialize = function () {
         this.showValidationErrors();
         this.expandLocationResults();
         this.singleLocationResultDisplay();

         //The results which are disabled must not be clickable
         $(".locationRow .disabled a").each(function() {
            // FIXME: Change to not use Script URL
            //$(this).attr("href", "javascript:void(0);");
            $(this).attr("onclick", "return false;");
         });

         $(".locationRow .locationSearch").click(function () {
            var jThis = $(this),
               thisData = jThis.data(),
               data = jThis.parents(".locationRow").data("propertysearch");

            self.propertySearch(data.locationLid, data.showMore, data.displayName, thisData);
         });

         // Fix IE7 missed redraw by forcing display change.
         if (!this.m_bIsBound) {
            this.m_bIsBound = true;
            ajax.bindLoadEvent($('#dropdownContent'), function (){ 
               var elDropdown = document.getElementById('dropdownContent');
               elDropdown.style.display = 'none'; 
               elDropdown.style.display = 'block'; 
            });
         }
         
         $(".locationResultsDiv, .propertyResultsDiv, .officeResultsDiv, .agentResultsDiv").hover(function () {
            if ($(this).find('.freetextsearchLabelNoData').length === 0){
                $(this).addClass('parentHover');
            }
         }, function() {
            $(this).removeClass('parentHover');
         });
      };

      /** 
       * Hide other sections for a single location result display
       */
      this.singleLocationResultDisplay = function () {
         if (!window.fts) return;

         if (window.fts.suggestType === 'SINGLE_LOCATION') {
            // Hide properties section only if there are none
            // Need to show MLS matched properties if any
            if (window.fts.hasProperties !== 'true') {
               $("#propertyResultsDiv").hide();
            }               
            $("#officeResultsDiv").hide();
            $("#agentResultsDiv").hide();
         }
      };

      /**
       * Add a class when the more location results are displayed
       */
      this.expandLocationResults = function () {
         if (!window.fts) return;

         var strShowMore = window.fts.showMore;

         if (strShowMore === 'L') {
            $(".freeTxtResults.location").addClass("megaextended");
         }
      };

      /**
       * Show the validation errors
       */
      this.showValidationErrors = function () {
         var count = $("#validationErrorCount").val(),
            errors = "";

         if(count > 0) {
            $("#searchValidationErrors .errordisplay").each(function () {
               var error = $(this).html();
               errors += error + "\r\n";
            });

            //alert(errors);
         }
      };
      
      /**
       * Set the search rental flag.
       * 
       */
      this.searchRental = function() {
         $("#searchRental").val("Y");  
      };

      /**
       * Set the search open houses flag.
       * 
       */
      this.searchOpenHouses = function() {
         $("#searchOpenHouses").val("Y");  
      };
      
      /**
       * Set the search recently reduced flag.
       * 
       */
      this.searchRecentlyReduced = function() {
         $("#searchRecentlyReduced").val("Y");  
      };
      
      /**
       * Set the search newly listed flag.
       * 
       */
      this.searchNewlyListed = function() {
         $("#searchNewlyListed").val("Y");  
      };
      
      /**
       * Set the search foreclosures flag.
       * 
       */
      this.searchForeclosures = function() {
         $("#searchForeclosures").val("Y");  
      };
      
      /**
       * Google Analytics Tracking:
       * Exact Location Match
       * 
       */
      this.gaTrackExactLocationMatch = function(locationID, selectedLidType) {
         if(locationID !== null && locationID.length > 0 && selectedLidType !== null && selectedLidType.length > 0) {
            if (selectedLidType === 'C') {
               track.doEvent('FTS Exact', 'City', locationID);
            } else if (selectedLidType === 'S') {
               track.doEvent('FTS Exact', 'State', locationID);
            } else if (selectedLidType === 'Z') {
               track.doEvent('FTS Exact', 'Zip', locationID);
            } else if (selectedLidType === 'N') {
               track.doEvent('FTS Exact', 'County', locationID); 
            } else if (selectedLidType === 'P' || selectedLidType === 'Q' || selectedLidType === 'R') {
               track.doEvent('FTS Exact', 'Neighborhood', locationID); 
            }
         }
      };      
      
      /**
       * Google Analytics Tracking:
       * Exact Office Match
       * 
       */
      this.gaTrackExactOfficeMatch = function(officeID) {
         if(officeID !== null && officeID.length > 0) {
     	    track.doEvent('FTS Exact', 'Office Name', officeID);
     	 }
      };
      
      /**
       * Google Analytics Tracking:
       * Exact Agent/Team Match
       * 
       */
      this.gaTrackExactAgentMatch = function(agentID, isTeam) {
    	  if(agentID !== null && agentID.length > 0) {
    		  if(isTeam !== null && isTeam === true) {
    		     track.doEvent('FTS Exact', 'Team Name', agentID);
    		  } else {
    			 track.doEvent('FTS Exact', 'Agent Name', agentID); 
    		  }
    	  }
      };      
      
      /**
       * Google Analytics Tracking:
       * Exact Property Match
       * 
       */
      this.gaTrackExactPropertyMatch = function(propertyID, isMLSSearch) {
    	  if(propertyID !== null && propertyID.length > 0) {
    		  if(isMLSSearch !== null && isMLSSearch === "true") {
    		     track.doEvent('FTS Exact', 'Property MLS #', propertyID);
    		  } else {
    			 track.doEvent('FTS Exact', 'Property Address', propertyID);
    		  }
    	  }    	  
      };
      
      /**
       * Property Search
       */
      this.propertySearch = function (locationLID, showMore, bEnterPressed, options) {
         var params = {
               locationId: locationLID,
               query: window.fts.searchText,
               showMore: showMore,
               listingsSearch: 'true'
            };

         if (options.newlylisted) params.newlyListed = options.newlylisted;
         if (options.rentals) params.rentals = options.rentals;
         if (bEnterPressed) params.enter = 1;

         // Ajax call to get more 
         ajax.doViewEngineAjax(
            'FreeTextSearchListingsSearch',
            '/eco/freetextsearch/',
            $.param(params),
            {
               cache: true
            }
         );
      };
      
      /**
       * Get more results of the type needed
       */
      this.showMore = function (searchType) {
         if(searchType === null || searchType.length === 0) {
            searchType = 'NONE';
         }
         
         // Ajax call to get more 
         ajax.doViewEngineAjax(
            'FreeTextSearchShowMore',
            '/eco/freetextsearch/',
            $.param({
               query: window.fts.searchText,
               enter: window.fts.enterKey,
               showMore: searchType,
               submitted: 'true'
            }),
            {
               cache: true
            }
         );
      };

      /**
       * Get all results of the type needed
       */
      this.viewAll = function (searchType) {
         if(searchType.length === 0) {
            searchType = 'NONE';
         }
         
         // Ajax call to get more 
         ajax.doViewEngineAjax(
            'FreeTextSearchViewAll',
            '/eco/freetextsearch/',
            $.param({
               query: window.fts.searchText,
               enter: window.fts.enterKey,
               viewAll: searchType,
               submitted: 'true'
            }),
            {
               cache: true
            }
         );
      };
   };

   return (new FreeTextSearch());
});
